"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMapEqual;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Returns `true` if both `Map` are different, otherwise, `false`.
 *
 * The equality of the value is compared using `Object.is`.
 */
function isMapEqual(x, y) {
  if (!x && y || x && !y) {
    return false;
  }

  var xKeys = new Set(x === null || x === void 0 ? void 0 : x.keys());
  var yKeys = new Set(y === null || y === void 0 ? void 0 : y.keys());

  if (xKeys.size !== yKeys.size) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(yKeys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      xKeys.add(key);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (xKeys.size !== yKeys.size) {
    return false;
  }

  var _iterator2 = _createForOfIteratorHelper(xKeys),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _key = _step2.value;

      if (!Object.is(x.get(_key), y.get(_key))) {
        return false;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return true;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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